import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`series`}</strong><br />{`series object or array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A single `}<a parentName="td" {...{
              "href": "/react-sim/api#series"
            }}>{`series`}</a>{` object. The accessor function is going to be called on every item in `}<inlineCode parentName="td">{`data`}</inlineCode>{` and a single number will be shown per series.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`height`}</strong><br />{`number, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Height of the indicator card.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`padding`}</strong><br />{`number, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Padding of the indicator card.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`width`}</strong><br />{`number, optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Width of the indicator card.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      